<script lang="ts">
  // Die Leiste des Sortiermodus -- überall dieselbe: über den Karten einer
  // Seite (AnordnungsWirt) und über dem Baum (shell/Explorer). Steht NUR
  // im Modus da; im Normalzustand gibt es keinen Anordnen-Knopf, gedrückt
  // halten öffnet ihn. Zurücksetzen als Symbol (nur bei eigener
  // Reihenfolge), „Fertig" beschriftet -- wie auf dem Dashboard.
  //
  // data-arrange-keep: ein Druck auf die Leiste zählt nicht als „daneben"
  // und beendet den Modus nicht, bevor ihr Klick ankommt.
  import Icon from "./Icon.svelte";
  import SymbolKnopf from "./SymbolKnopf.svelte";
  import { t } from "./i18n.svelte";

  interface Props {
    text: string;
    /** eigene Reihenfolge vorhanden → Zurücksetzen zeigen */
    angepasst: boolean;
    onzuruecksetzen: () => void;
    onfertig: () => void;
    /** schmale Fläche (Baum): der Satz in eigener Zeile, Knöpfe darunter */
    schmal?: boolean;
    class?: string;
    style?: string;
  }
  let { text, angepasst, onzuruecksetzen, onfertig, schmal = false, class: klasse = "", style }: Props = $props();
</script>

<!-- Schmal (Baum, ~200 px): der Satz bekommt eine eigene Zeile, die
     Knöpfe stehen darunter rechts -- abgeschnitten hieß er nur „Zeil…". -->
<div
  data-arrange-keep
  class="leiste border-accent/40 text-fg-muted flex items-center border t-meta {schmal
    ? 'flex-wrap gap-x-2 gap-y-0.5 rounded-lg py-1 pr-1 pl-2.5'
    : 'min-h-11 gap-2 rounded-xl py-1 pr-1.5 pl-4'} {klasse}"
  {style}
>
  {#if schmal}
    <span class="flex basis-full items-start gap-1.5 pt-0.5 pr-1.5">
      <Icon name="move" size={13} class="text-accent mt-px shrink-0" />
      <span class="min-w-0">{text}</span>
    </span>
  {:else}
    <Icon name="move" size={14} class="text-accent shrink-0" />
    <span class="min-w-0 flex-1 truncate" title={text}>{text}</span>
  {/if}
  <span class="flex shrink-0 items-center gap-1 {schmal ? 'ml-auto' : ''}">
    {#if angepasst}
      <SymbolKnopf icon="rotate-ccw" label={t("anordnung.zuruecksetzen", "Reihenfolge zurücksetzen")} onclick={onzuruecksetzen} />
    {/if}
    <button
      type="button"
      onclick={onfertig}
      class="ctrl-s border-accent/50 bg-accent/10 text-accent shrink-0 rounded-lg border t-meta transition"
    >
      <Icon name="check" size={13} />
      {t("anordnung.fertig", "Fertig")}
    </button>
  </span>
</div>

<style>
  /* deckend: über den Karten laufen beim Scrollen die Karten durch */
  .leiste {
    background: color-mix(in oklab, var(--bedien) 8%, var(--bg-elev));
  }
</style>
